<template>
  <section>
    <header class="flex relative items-center text-22 text-white gap-1">
      <VideoPlayIcon class="w-7 h-7" />
      <div class="relative">
        {{ $t('news-page.videos-of-article') }}
        <div class="text-md absolute -right-15 top-1.5 bg-[#181819] px-2 text-primary-300">{{ renderVideos.currentPlaying }}</div>
      </div>
      <HideShowButton v-if="isMobile" class="absolute right-0 top-0.5" event="click_nextVideoHideShowButton" @hide-show="handleShowHide" />
      <div class="flex-grow border-b border-[#666666]"></div>
    </header>
    <TransitionSlot>
      <div v-if="isShow" class="flex flex-col gap-2 max-h-[630px] overflow-y-auto mt-5">
        <NextVideoItem
          v-for="(video, index) in renderVideos.videos"
          :key="video._id"
          :video="video"
          :index="index"
          :active="video.active"
          @selected-video="selectedVideo(video, index)"
        />
      </div>
    </TransitionSlot>
  </section>
</template>

<script>
import { defineComponent, computed, ref } from '@nuxtjs/composition-api';
import VideoPlayIcon from '@/static/images/video/video-play.svg?inline';
import NextVideoItem from './NextVideoItem';
import HideShowButton from './HideShowButton';
import TransitionSlot from './TransitionSlot';
import { useDevice } from '~/composables/useDevice';

export default defineComponent({
  components: {
    TransitionSlot,
    VideoPlayIcon,
    NextVideoItem,
    HideShowButton,
  },
  props: {
    videos: {
      type: Array,
      require: true,
    },
    currentVideoId: {
      type: String,
      require: false,
    },
  },
  setup(props, { emit }) {
    const isShow = ref(true);
    const { isMobile } = useDevice();
    const renderVideos = computed(() => {
      const videos = props.videos.map((video, index) => {
        return { ...video, active: video?.videoData.id === props.currentVideoId, index: index + 1 };
      });
      const currentPlaying = (videos.find((video) => video.active === true && video.index)?.index || '0') + '/' + props.videos.length;
      return {
        videos,
        currentPlaying,
      };
    });

    const selectedVideo = (video, index) => emit('selected-video', { video, index });
    const handleShowHide = (toggle) => (isShow.value = toggle);

    return { isShow, renderVideos, selectedVideo, handleShowHide, isMobile };
  },
});
</script>
